export default __webpack_public_path__ + "static/media/43_BottomRightSquares_RotateRight.f46d98c8.mp4";